module.exports = __webpack_public_path__ + "static/media/modal_rank_simple_bg.e9e9c7a7.png";